import { CheckoutCardPaymentDetails } from './checkout-card-payment-details.interface';
import { CheckoutDirectDebitPaymentDetails } from './checkout-direct-debit-payment-details.interface';

export type CheckoutPaymentDetails =
  | CheckoutCardPaymentDetails
  | CheckoutDirectDebitPaymentDetails;
